import { render } from "./glassitem-viewselect.vue?vue&type=template&id=4bfcecb2"
import script from "./glassitem-viewselect.vue?vue&type=script&lang=js"
export * from "./glassitem-viewselect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__